import AddNote from "./AddNote";
import { useState } from "react";
import { NotesDisplayWithAdd, ENGAGEMENT_NOTES_COLUMNS } from "src/components/NotesDisplay";
import { useCommunications } from 'src/careflow/ph-core/fhir-client/fhir-react';
import { CommunicationWrapper } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Communication';
import { mapCommunicationsToNotesDisplay } from 'src/careflow/common/common-utils';
import { WrappedPatient } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient';

type Props = {
  patient: WrappedPatient | null;
  isAllowedToAdd: boolean;
  patientEngagement?: any;
}

export default function NotesList({ patient, isAllowedToAdd, patientEngagement }: Props) {
  const [open, setOpen] = useState(false);

  const [communications, { create: createCommunication, refresh: refreshCommunications }] =
    useCommunications({ 
      filter: { 
        subject: patient?.id
      }, 
      map: CommunicationWrapper 
    });

  const handleCreateCommunication = async (data: any) => {
    try {
      await createCommunication(data);
      refreshCommunications();
    } catch (err) {
      console.error('Error creating Patient Engagement note:', err);
    }
  };

  const mappedNotesData = mapCommunicationsToNotesDisplay(communications, ['notes_patient_engagement']);

  return (
    <>
      <NotesDisplayWithAdd
        data={mappedNotesData}
        columns={ENGAGEMENT_NOTES_COLUMNS}
        titleButton={isAllowedToAdd ? "Add Note" : undefined}
        isAllowedToAdd={isAllowedToAdd}
        onAddNote={() => setOpen(true)}
        emptyMessage="No notes available"
      />
      <AddNote
        openDialog={open}
        patient={patient}
        patientEngagement={patientEngagement}
        onCreate={handleCreateCommunication}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
